module.exports = __webpack_public_path__ + "img/dino.cc830c42.jpg";